import React, { Component } from 'react'
import { DropdownButton, MenuItem } from 'react-bootstrap'

export default class LinkDropdown extends Component {
	render(){

		let title  = this.props.title;
		let options = this.props.children;

		const { onSelectElement } = this.props

		return (
			<DropdownButton bsStyle="link" title={title} id={title} onSelect={ onSelectElement }>
	  		{options.map((item, index) =>
					<MenuItem key={index} eventKey={item.id}>{item.name}</MenuItem>	
				)}    
	    </DropdownButton>						
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Buttons/linkDropdown/index.js